module.exports = __webpack_public_path__ + "static/media/speaker-page-row-1.677d02f3.png";